/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState, useCallback } from 'react'
import { Typography, Box, IconButton } from '@mui/material'
import { AnnouncementBoardIcon, LinkedInBoardIcon, TwitterBoardIcon } from '@/src/assets/icons'
import CommonApi from '@/pages/api'
import Link from 'next/link'

const MIN_ITEM_WIDTH = 300

const GRID_SX = {
  gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${MIN_ITEM_WIDTH}px), 1fr))`
}

interface BoardSectionProps {
  sectionId: number
  isDraft?: boolean
}

const BoardSection = ({ sectionId, isDraft = false }: BoardSectionProps) => {
  const [boardSectionData, setBoardSectionData] = useState<any>()

  const fetchBoaredSectionData = useCallback(async () => {
    try {
      const response = await CommonApi({
        method: 'get',
        path: `show-board-management/${sectionId}${isDraft ? '?status=draft' : ''}`
      })
      if (response?.status) {
        setBoardSectionData(response?.data)
      } else {
      }
    } catch (error) {
      console.log(error)
    }
  }, [sectionId, isDraft])

  useEffect(() => {
    fetchBoaredSectionData()
  }, [fetchBoaredSectionData])

  return (
    <Box className={`flex`}>
      <Box className="w-full flex flex-col lg:flex-row gap-0 lg:gap-14">
        {boardSectionData?.show_board && (
          <Box
            className={`w-full ${
              boardSectionData?.show_management
                ? 'lg:w-[669px] flex flex-col gap-6'
                : 'flex flex-col gap-6'
            }`}
          >
            <Box className="flex justify-between items-center">
              <Typography
                variant="h5"
                // color="primary"
                className=" self-center h-[38px]"
              >
                {boardSectionData?.board_title ?? 'Board'}
              </Typography>
            </Box>
            <Box>
              <Box
                className="grid gap-2"
                sx={GRID_SX}
              >
                {boardSectionData?.board_data?.map((item: any, index: any) => (
                  <Box key={index} className="w-full bg-[#07004D14] p-2 pr-3 rounded-full">
                    <Box className="flex gap-2 w-full">
                      <img
                        className="w-[72px] h-[72px] shrink-0 object-cover"
                        src={item?.profile_img}
                        style={{
                          borderRadius: '100%',
                          backgroundColor: '#ADA0FF'
                        }}
                        alt=""
                      />
                      <Box className="w-full min-w-0 items-center flex justify-between pl-1">
                        <Box className="min-w-0">
                          <Typography variant="subtitle1">{item?.name}</Typography>
                          <Typography variant="caption">{item?.title}</Typography>
                        </Box>
                        <Box className="flex shrink-0">
                          {item?.x_link != '' && (
                            <Link href={`${item?.x_link}`} target="_blank">
                              <Box
                                className={`self-center ${
                                  !item?.linkedin_link && !item?.other_link ? 'mr-4' : ''
                                }`}
                              >
                                <IconButton className="p-1" size="small">
                                  <TwitterBoardIcon />
                                </IconButton>
                              </Box>
                            </Link>
                          )}
                          {item?.linkedin_link != '' && (
                            <Link
                              href={`${item?.linkedin_link}`}
                              target="_blank"
                              className="self-center"
                            >
                              <Box
                                className={`${!item?.x_link && !item?.other_link ? 'mr-4' : ''}`}
                              >
                                <IconButton className="p-1 " size="small">
                                  <LinkedInBoardIcon />
                                </IconButton>
                              </Box>
                            </Link>
                          )}
                          {item?.other_link != '' && (
                            <Link href={`${item?.other_link}`} target="_blank">
                              <Box
                                className={`self-center ${
                                  !item?.linkedin_link && !item?.x_link ? 'mr-4' : ''
                                }`}
                              >
                                <IconButton className="p-1" size="small">
                                  <AnnouncementBoardIcon classes="fill-secondary-main" />
                                </IconButton>
                              </Box>
                            </Link>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        )}
        {boardSectionData?.show_management && (
          <Box
            className={`w-full ${
              boardSectionData?.show_board
                ? 'lg:w-[669px] flex flex-col gap-6'
                : 'flex flex-col gap-6'
            }`}
          >
            <Box className=" flex justify-between items-center mt-6 lg:mt-0">
              <Typography className=" self-center  h-[38px]" variant="h5">
                {boardSectionData?.management_title ?? 'Management'}
              </Typography>
            </Box>
            <Box>
              <Box
                className="grid gap-2"
                sx={GRID_SX}
              >
                {boardSectionData?.management_data?.map((item: any, index: number) => (
                  <Box key={index} className="w-full bg-[#07004D14] p-2 pr-3 rounded-[50px]">
                    <Box className="flex gap-2 w-full">
                      <img
                        className="w-[72px] h-[72px] shrink-0 object-cover"
                        src={item?.profile_img}
                        alt=""
                        style={{
                          borderRadius: '100%',
                          backgroundColor: '#ADA0FF'
                        }}
                      />
                      <Box className="w-full min-w-0 items-center flex justify-between pl-1">
                        <Box className="min-w-0">
                          <Typography variant="subtitle1">{item?.name}</Typography>
                          <Typography variant="caption" className="h-[20px]">
                            {item?.title}
                          </Typography>
                        </Box>
                        <Box className="flex shrink-0">
                          {item?.x_link != '' && (
                            <Link href={`${item?.x_link}`} target="_blank">
                              <Box
                                className={`self-center ${
                                  !item?.linkedin_link && !item?.other_link ? 'mr-4' : ''
                                }`}
                              >
                                <IconButton className="p-1" size="small">
                                  <TwitterBoardIcon />
                                </IconButton>
                              </Box>
                            </Link>
                          )}
                          {item?.linkedin_link != '' && (
                            <Link
                              href={`${item?.linkedin_link}`}
                              target="_blank"
                              className="self-center"
                            >
                              <Box
                                className={`${!item?.x_link && !item?.other_link ? 'mr-4' : ''}`}
                              >
                                <IconButton className="p-1" size="small">
                                  <LinkedInBoardIcon />
                                </IconButton>
                              </Box>
                            </Link>
                          )}
                          {item?.other_link != '' && (
                            <Link href={`${item?.other_link}`} target="_blank">
                              <Box
                                className={`self-center ${
                                  !item?.linkedin_link && !item?.x_link ? 'mr-4' : ''
                                }`}
                              >
                                <IconButton className="p-1" size="small">
                                  <AnnouncementBoardIcon classes="fill-secondary-main" />
                                </IconButton>
                              </Box>
                            </Link>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default BoardSection
